import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { totalModel } from './totalModel'
import { SettleDetail } from '../detail'
import { SnippetsOutlined } from "@ant-design/icons";
import YhTootip from '@/components/YhTootip'

export function DataTable() {

    const {
        dataSource, pgCfg,
        loadData, loading,
        selectedRowKeys, setSelectedRowKeys,
        mode, setMode,
        visible, setVisible,
        billCode, setBillCode,
        billOrderVisible, setBillOrderVisible
    } = totalModel()

    useEffect(() => {
        loadData()
    }, [])

    const columns: any[] = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            dataIndex: '',
            render: (t, r, i) => i + 1,
        },
        {
            title: '账单编号',
            width: 150,
            align: 'center',
            dataIndex: 'code',
            render: (text, r) => (
                <div
                    style={{ color: 'rgb(62, 103, 244)', cursor: 'pointer' }}
                    onClick={() => { setBillCode(text); setBillOrderVisible(true); }}>
                    {text}
                </div>
            ),
        },
        {
            title: '',
            width: 20,
            align: 'center',
            dataIndex: '',
            render: (text) => {
                return <i style={{ color: "#5200ff" }} onClick={() => { setMode("look"); setVisible(true); }}>
                    <SnippetsOutlined />
                </i>
            }
        },
        {
            title: '加盟商名称',
            width: 160,
            align: 'center',
            dataIndex: 'partnerName',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '账单状态',
            width: 100,
            align: 'center',
            dataIndex: 'status',
            render: (text) => {
                return text === 0 ? '初始' : text === 1 ? '已记账' : text === 2 ? '已核销' : text === 3 ? '待复核' : '';
            },
        },
        {
            title: '工单数量',
            width: 100,
            align: 'center',
            dataIndex: 'num',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '账单金额',
            width: 100,
            align: 'center',
            dataIndex: 'billAmount',
            render: (text) => <YhTootip text={text} style={{ width: '100px' }} />,
        },
        {
            title: '结算金额(发票金额）',
            width: 160,
            align: 'center',
            dataIndex: 'invoiceAmount',
            render: (t, r) => {
                return r.billInvoiceList.map(e => e.invoiceAmount).reduce((acc, cur) => acc + cur, 0).toFixed(2);
            }
        },
        {
            title: '发票类型',
            width: 200,
            align: 'center',
            dataIndex: 'invoiceTypeName',
            render: (t, r) => {
                const billInvoice = r?.billInvoiceList?.[0];
                return billInvoice == null ? "" : billInvoice.invoiceTax + billInvoice.invoiceTypeName
            }
        },
        {
            title: '出账开始日期',
            width: 100,
            align: 'center',
            dataIndex: 'fixedCreateTime',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '出账结束日期',
            width: 100,
            align: 'center',
            dataIndex: 'fixedEndTime',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '付款时间',
            width: 100,
            align: 'center',
            dataIndex: 'writeoffTime',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '结算员',
            width: 100,
            align: 'center',
            dataIndex: 'writeoffUser',
            render: (text) => <YhTootip text={text} />,
        },
    ]

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                rowSelection={{
                    type: "radio",
                    selectedRowKeys: selectedRowKeys,
                    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                    }
                }}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => setSelectedRowKeys([record.id]),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record.id])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 470px)' }}
            />

            <SettleDetail visible={billOrderVisible} setVisible={setBillOrderVisible} />
        </>
    )
}
